<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <SportCreateAndUpdateFormItems
            :form="form" />
    </VForm>
</template>
<script>
import VForm from '@/components/VForm.vue'
import { rootActions } from '@/store/types'
import Form from '@/mixins/Form'
import SportCreateAndUpdateFormItems from '@/components/SportCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        SportCreateAndUpdateFormItems,
    },
    mixins: [Form],
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_SPORT, { ...values },
            )
            return res
        },
    },
}
</script>
